$shm_hitalama_guide_editor $mol_page
	title \Редактирование руководства
	catalog $shm_hitalama_guide_catalog
	id \
	opened? true
	tools /
		<= Save $mol_button_major
			title \Сохранить
			enabled <= dirty false
			click? <=> save? null
		<= Cancel $mol_button_minor
			title \Отменить изменения
			click? <=> cancel? null
		<= Delete $shm_confirm_delete
			title \Удалить страницу
			question \Удалить страницу руководства? Страницу со входящими ссылками удалить нельзя.
			confirmed? <=> remove? null
		<= Close $mol_button_minor
			hint \Закрыть редактор
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Name $mol_labeler
			title \Название страницы
			Content <= Name_input $mol_string
				value? <=> name? \
		<= Parent $mol_labeler
			title \Группа
			Content <= Parent_input $mol_select
				dictionary <= folder_options *
				value? <=> parent? \
		<= Body_text $mol_labeler
			title \Текст Markdown
			Content <= Text_input $mol_textarea
				value? <=> content_text? \
		<= Status $mol_status
			status <= status \
